module.exports = "<!--Company Tags -->\n<div class=\"form-group\">\n\t<label class=\"form-control sr-only\" for=\"customTags\"> Custom Filters </label>\n\t<select multiple chosen ng-change=\"tagsCtrl.callback(tagsCtrl.selectedTags)\" class=\"form-control m-t-xl\"\n\t        id=\"customTags\"\n\t        name=\"customTags\"\n\t        ng-model=\"tagsCtrl.selectedTags\"\n\t        ng-options=\"tag.name group by tag.group for tag in tagsCtrl.tagsList\">\n\t\t<option value=\"\"></option>\n\t</select>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/forms/tags/template.html
// module id = 1471
// module chunks = 0